











































































































































import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import GenericTemplate from '@/pages/Pages/Templates/GenericTemplate.vue';
import { SmsTextInputWings } from '@/components/SMS';
import { MsgTransports } from '@/store/types';
import { TemplateItemImpl } from '@/store/settings/templates/types';
import { Route } from 'vue-router';
import { CustomTemplateItem } from '@/store/custom/templates/types';
import {removeItem} from "@/utils/data-helper";
import {SelectWings, NewPriceWings} from "wings-ui-components";

Component.registerHooks(['beforeRouteLeave']);

@Component({components: {NewPriceWings,SelectWings, GenericTemplate, SmsTextInputWings}})
export default class CustomTemplate extends Vue {
  @Prop() moderation!: boolean;
  @Ref('genericTemplate') genericTemplate!: GenericTemplate;
  @Ref('validatorUserOptions') validatorUserOptions: any;

  private transport: MsgTransports = MsgTransports.CUSTOM;
  private templateObject: CustomTemplateItem = new TemplateItemImpl();
  private selectedItems = [];

  beforeRouteLeave(to: Route, from: Route, next: any) {
    this.genericTemplate.beforeLeave(to, from, next);
  }

  created() {
    this.templateObject.custom_parameters = [{name: 'SAN', value: '123ac45z67'}]
  }

  get atLeastOneIsFull(): boolean {
    let result: boolean = !!this.templateObject.image_link
        || !!this.templateObject.button_name
        || !!this.templateObject.button_link;
    return result;
  }
  onLoadTemplate(status: string) {
    if (this.moderation) {
      this.$emit('onLoadTemplate', status)
    }
  }

  onSelect(items: any) {
    this.selectedItems = items;
  }

  async addEmptyItem():Promise<void> {
    let valid:boolean = await this.validatorUserOptions.validate();
    if (valid){
      if (this.templateObject.custom_parameters === undefined) {
        this.templateObject.custom_parameters = [];
      }
      this.templateObject.custom_parameters.push({name: undefined, value: undefined});
    }
  }

  deleteSelectedItem(): void {
    if (this.templateObject.custom_parameters) {
      this.selectedItems.forEach((item: any) =>
          removeItem(this.templateObject.custom_parameters, item));
    }
    if (this.templateObject.custom_parameters?.length === 0) {
      this.addEmptyItem();
    }
  }

}
